module.exports = {
	"articleTitle1": "Benefits of cars on campus a plus",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "Mitchell Field",
	"articleLink2": "https://www.michigandaily.com/section/columns/megan-mitchell-short-skirt-long-jacket",
	"articleSnippet1": "Jan 17, 2002 ... Engineering Junior James Shavers has a University parking permit at a lot by \nMitchell Field. \"It\"s nothing I can just walk to parking permits ...",
	"articleSnippet2": "Oct 13, 2015 ... In a recent New York Times article, Eileen Pollack, a creative writing professor at \nthe University, shared the reasons she left the scientific field ...",
	"totalMisc": 0,
	"articleTitle2": "Megan Mitchell: Short skirt, long jacket ",
	"address": "1900 Fuller Rd, Ann Arbor, MI 48105",
	"images": [],
	"position": {
		"lat": 42.286591,
		"lng": -83.723105
	},
	"tips": [
		{
			"text": "Nice place for pickup games. Not too far away for those living on North Campus",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/content/benefits-cars-campus-plus",
	"categories": {
		"yogaspot": 1,
		"pickupsports": 1,
		"location": 1,
		"recarea": 1,
		"sunbathingspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mitchellfield.json
// module id = 924
// module chunks = 0